import { get } from "./request";

/**
 * Dashboard 相关接口（API 文档第 3 节 /console/dashboard）。
 */

// ---------- 类型定义 ----------

/** GET /dashboard/summary */
export interface DashboardSummary {
  /** 历史累计 API 调用次数 */
  totalCalls: number;
  /** 历史累计消费（分） */
  totalCostCents: number;
  /** 当月 API 调用次数 */
  monthCalls: number;
  /** 今日 API 调用次数 */
  todayCalls: number;
  /** 累计商品查询次数（detail + discover） */
  totalProductsQueried: number;
  /** 累计订单数 */
  totalOrders: number;
  /** 累计 GMV（分） */
  totalGmvCents: number;
  /** 上月订单数 */
  lastMonthOrders: number;
  /** 上月 GMV（分） */
  lastMonthGmvCents: number;
  /** 上月商品查询次数 */
  lastMonthProductsQueried: number;
  /** 当月订单数 */
  currentMonthOrders: number;
  /** 当月 GMV（分） */
  currentMonthGmvCents: number;
  /** 今日订单数 */
  ordersToday: number;
  /** 今日 GMV（分） */
  gmvTodayCents: number;
  /** 昨日订单数 */
  ordersYesterday: number;
  /** 昨日 GMV（分） */
  gmvYesterdayCents: number;
}

/** GET /dashboard/credits */
export interface DashboardCredits {
  monthlyCreditsCents: number;
  purchasedCreditsCents: number;
  totalBalanceCents: number;
  planMonthlyCreditsCents: number;
  periodEnd: string;
  planCode: string;
}

/** GET /dashboard/api-trends 单项 */
export interface ApiTrendPoint {
  date: string;
  api_code: string;
  calls: number;
  cost_cents: number;
}

/** GET /dashboard/recent-credits 单项 */
export interface RecentCreditActivity {
  type: "RECHARGE" | "MONTHLY_RESET" | "CONSUME" | string;
  monthly_cents: number;
  purchased_cents: number;
  api_code: string | null;
  remark: string | null;
  created_at: string;
}

// ---------- 接口函数 ----------

export function getDashboardSummary(): Promise<DashboardSummary> {
  return get<DashboardSummary>("/dashboard/summary");
}

export function getDashboardCredits(): Promise<DashboardCredits> {
  return get<DashboardCredits>("/dashboard/credits");
}

export function getApiTrends(days = 30): Promise<ApiTrendPoint[]> {
  return get<ApiTrendPoint[]>("/dashboard/api-trends", { params: { days } });
}

/** GET /dashboard/order-trends 单项 */
export interface OrderTrendPoint {
  date: string;
  orders: number;
  gmv_cents: number;
}

export function getOrderTrends(days = 30): Promise<OrderTrendPoint[]> {
  return get<OrderTrendPoint[]>("/dashboard/order-trends", {
    params: { days },
  });
}

export function getRecentCredits(): Promise<RecentCreditActivity[]> {
  return get<RecentCreditActivity[]>("/dashboard/recent-credits");
}
